export default function (store) {
    const { taskShape } = store.getState();
    taskShape.completed.taskHide = false;
    store.setState({ taskShape });
}
//# sourceMappingURL=showCompleted.js.map